import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 23v-6h2.5v-2H3V9h2.5V7H3V1h7v6H7.5v2H10v2h4V9h7v6h-7v-2h-4v2H7.5v2H10v6Zm2-2h3v-2H5Zm0-8h3v-2H5Zm11 0h3v-2h-3ZM5 5h3V3H5Zh2Zh1"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "NetDiagram"}) } }